import { Box, Card, Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';

import { useSupportPageStyles } from './support-page-styles';

export const SupportNumberCard: React.VFC = () => {
  const { classes } = useSupportPageStyles();
  const l10n = useL10n();

  return (
    <Box className={classes.gridItem}>
      <Card className={classes.cardRight}>
        <Typography variant="h4" color="secondary" className={classes.cardTitle}>
          {l10n.support.giveCall}
        </Typography>
        <Box color="darkSlate" mt={4}>
          <Typography variant="h4" className={classes.supportNumber}>{l10n.support.supportNumber}</Typography>
        </Box>
        <Box mt={3}>
          <Typography>
            <span dangerouslySetInnerHTML={{ __html: l10n.support.supportAvailabilityProvider }} />
          </Typography>
        </Box>
      </Card>
    </Box>
  );
};
